import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { setShowNewQuestion } from '../../containers/App/actions';

import Button from '../Button';


const NewQuestionButton = (props) => (
  <Button onClick={props.newQuestion}>Choose a new question</Button>
);

const mapStateToProps = createStructuredSelector({});

export function mapDispatchToProps(dispatch) {
  return {
    newQuestion() {
      dispatch(setShowNewQuestion(true));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

NewQuestionButton.propTypes = {
  newQuestion: PropTypes.func,
};

export default compose(
  withConnect,
)(NewQuestionButton);



// WEBPACK FOOTER //
// ./app/components/NewQuestionButton/index.js